<mat-divider></mat-divider>
<footer>
    &copy; All rights reserved 2019
</footer>